import { Button, Grid2, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/FormFields/TextFormField';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomDivider, { OrDivider } from '../../shared/utils/CustomDivider';
import { useMutation } from '@tanstack/react-query';
import { useApartmentListForCourse, useCityListWithoutState, useGetAllSubjectList, useSchoolList, useZoneList } from '../../assets/api/useGetApi';
import ReCAPTCHA from 'react-google-recaptcha';
import useAuthStore from '../../shared/store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { PhoneInputFormField } from '../../shared/components/FormFields/PhoneInputFormField';
import { plainAxios } from '../../assets/nodeApi/postApi/postAuthApi';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';
import { useDialog } from '../../shared/hook/useDialog';
import { postResendOtp, postSendOtp, postVerifyOtp } from '../../assets/nodeApi/postApi/postCommonApi';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';
import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete';
import { CaptchaKey } from '../../shared/constants';
import { FileUploadFormField } from '../../shared/components/FormFields/FileUploadFormField';
import { AutoCompleteField } from '../../shared/components/FormFields/AutoCompleteField';
import { useCheckUserExistance } from '../../assets/nodeApi/getApi/getCommonApi';
import { ImgText } from '../../shared/utils/Heading';
import UtItem from '../../shared/components/UtList';
import { isValidPhoneNumber } from "react-phone-number-input";
import { useDebounce } from '../../shared/hook/useDebounce';

const CommonNodeSignUpForm = ({ bottomLine, role, signupRoute, loginRoute }) => {

    const { login } = useAuthStore()
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState(null);
    const [username, setUserName] = useState("")
    const debouncedEmail = useDebounce(email, 500);
    const debouncedUsername = useDebounce(username, 500);
    const { data: userExistance } = useCheckUserExistance({ type: role === "apartment" ? "apartment" : "user", email: debouncedEmail, username: debouncedUsername })
    const { open: openChooseOp, handleClickOpen: handleClickOpenChooseOp, handleClose: handleCloseChooseOp } = useDialog();
    const { open: openApartment, handleClickOpen: handleClickOpenApartment, handleClose: handleCloseAparment } = useDialog();
    const { open, handleClickOpen, handleClose } = useDialog();
    const [isVerified, setIsVerified] = useState(false);
    const [cityId, setCityId] = useState();
    const { showToaster } = useToaster();
    const [captchaValue, setCaptchaValue] = useState(null);
    const [isStyingApartment, setIsStyingApartment] = useState(true)
    const recaptchaRef = useRef(null);
    const navigate = useNavigate()
    const location = useLocation()
    const ssoData = location.state?.ssoData;
    console.log("CommonNodeSignUpForm using ssoData:", ssoData);

    const [errorText, setErrorText] = useState("")
    const [countdown, setCountdown] = useState(0);
    const [searchCity, setSearchCity] = useState("")
    const debouncedSearchCity = useDebounce(searchCity, 500);
    const { data: cityList, isLoading: cityLoading } = useCityListWithoutState({ search: debouncedSearchCity });
    const [apartmentId, setApartmentId] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState([])
    const [searchSubject, setSearchSubject] = useState("")
    const getFirstNameLabel = () => role === "student" ? "Parent's Name" : "First Name";
    const getLastNameLabel = () => role === "student" ? "Student's Name" : "Last Name";

    const { data: preferredSubject, isLoading: ispreferredSubjectLoading } = useGetAllSubjectList({
        search: searchSubject,
        status: "active"
    })

    const subjects =
        preferredSubject?.pages?.flatMap((page) => page.data) ?? [];

    const preferredSubjectOption = subjects?.map((item, index) => ({
        id: item?.id,
        label: item?.subject,
        value: item?.subject,
    })) || []

    const handleRemove = (id) => {
        setSelectedSubject(prev => prev?.filter(item => item?.id !== id));
    };

    useEffect(() => {
        if (role === "student") {

            handleClickOpenChooseOp()
        }
        
        // Pre-fill email and username from SSO if available
        if (ssoData?.email) {
            setEmail(ssoData.email);
        }
        if (ssoData?.name) {
            setUserName(ssoData.name);
        }

        return () => clearInterval(timerRef.current);

    }, [ssoData, role]);

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
        setErrorText("")
    };

    const cityOption = cityList?.data?.map((item) => ({
        id: item?.id,
        label: item?.city_name,
        value: item?.city_name,
        city_id: item?.id
    }));

    const { data: ZoneList, isLoading: isLoadingZone } = useZoneList({ city_id: cityId });

    const ZoneOption = ZoneList?.data?.map((item) => ({
        id: item?.id,
        value: item?.zone_name,
        label: item?.zone_name
    })) || [];

    const { data: schoolList, isLoading: isSchoolLoading } = useSchoolList()

    const schoolOption = schoolList
        ?.data?.filter(item => item?.is_verified !== "Verified")
        ?.map((item, index) => ({
            id: index + 1,
            label: item?.school_name,
            value: item?.school_name,
        })) || [];

    const timerRef = useRef(null);

    const [selectedApartmentDetail, setSelectedApartmentDetail] = useState({})

    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();

    const ApartmentOptions = apartmentList?.data
        ?.filter((item) => item?.is_verified !== 1)
        .map((item) => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        })) || [];

    const ApartmentOptionsStu = (apartmentList?.data || [])
        .filter(item => {
            const status = item?.terms_status || "";

            return (
                status.includes("Approved By") ||
                ["Accepted By Apartment", "Created"].includes(status)
            );
        })
        .map(item => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        }));

    const startCountdown = () => {
        setCountdown(300);
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const sendOtpMutation = useMutation({
        mutationFn: postSendOtp,
    });


    const verifyOtpMutation = useMutation({
        mutationFn: postVerifyOtp,
    });

    const handleSubmitOtp = async (values, { setSubmitting, resetForm, setFieldError }) => {
        const obj = {
            mobile: mobile,
            otp: values.otp,
        };

        verifyOtpMutation.mutate(obj, {
            onSuccess: () => {
                setFieldError('otp', '')
                handleClose();
                setIsVerified(true);
                resetForm();
            },
            onError: (error) => {
                setFieldError('otp', error?.response?.data?.message || 'Invalid OTP');
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });
    };



    const reSendOtpMutation = useMutation({
        mutationFn: postResendOtp,
    });

    const handleResendOtp = () => {
        reSendOtpMutation.mutate({ mobile: mobile }, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    startCountdown();
                }
            },
            onError: (error) => {
                showToaster('Error', "Something Went wrong", 'error')
            },
        });
    }

    const baseInitialValues = {
        firstname: ssoData?.name || "",
        lastname: "",
        email: ssoData?.email || "",
        mobile: "",
        password: "",
        username: ssoData?.name || "",
    };


    const checkIsExist = (field) => {
        const result = userExistance?.results?.find((r) => r.field === field);
        return result?.isExist;
    };

    let baseValidationSchema = {
        firstname: yup.string().trim().required(`${getFirstNameLabel()} is required`),
        lastname: yup.string().trim().required(`${getLastNameLabel()} is required`),
        username: yup
            .string()
            .trim()
            .required("User Name is required")
            .test("username-taken", "Username already exists", function (value) {
                if (!value || !userExistance) return true;
                return !checkIsExist("username");
            }),
        email: yup
            .string()
            .trim()
            .email("Invalid email format")
            .required("Email is required")
            .test("email-taken", "Email already exists", function (value) {
                if (!value || !userExistance) return true;
                return !checkIsExist("email");
            }),
        mobile: yup
            .string()
            .trim()
            .required("Mobile Number is required")
            .test(
                "is-valid-phone",
                "Enter a valid mobile number",
                function (value) {
                    if (!value) return false;
                    return isValidPhoneNumber(value);
                }
            ),


        ...(isVerified && {
            password: yup
                .string()
                .trim()
                .min(8, "Password must be at least 8 characters")
                .required("Password is required"),
            confirm_password: yup
                .string()
                .trim()
                .oneOf([yup.ref("password"), null], "Passwords must match")
                .required("Confirm Password is required"),
        }),


    };


    // Only add school fields if role is school
    if (role === "school") {

        Object.assign(baseInitialValues, {
            school_name: "",
            country_name: "",
            state: "",
            city: "",
            zip: "",
        });

        Object.assign(baseValidationSchema, {
            school_name: yup.string().required("School is required"),
            country_name: yup.string().required("Country Name is required"),
            state: yup.string().required("State Name is required"),
            city: yup.string().required("City Name is required"),
            zip: yup
                .string()
                .required("Pincode is required")
                .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
        });
    }

    if (role === "trainer") {
        Object.assign(baseInitialValues, {
            resume: "",
            qualification: "",
            preferred_subjects: "",
            preferred_location: "",
            preferred_zone: "",
        });

        Object.assign(baseValidationSchema, {
            resume: yup.string().required("Resume  is required"),
            qualification: yup.string().required("Qualification is required"),
            preferred_subjects: yup.string(),
            preferred_location: yup.string(),
            preferred_zone: yup
                .string()
        });
    }

    if (role === "student") {
        Object.assign(baseInitialValues, {
            apartment_name: "",
        });

        Object.assign(baseValidationSchema, {
            apartment_name: yup.string().when([], {
                is: () => isStyingApartment,
                then: (schema) => schema.required("Apartment is required"),
                otherwise: (schema) => schema.notRequired(),
            }),
        });
    }

    if (role === "apartment") {
        Object.assign(baseInitialValues, {
            apartment_name: "",
        });

        Object.assign(baseValidationSchema, {
            apartment_name: yup.string().required("Apartment is required"),
        });
    }

    const validationSchema = yup.object().shape(baseValidationSchema);
    const initialValues = baseInitialValues;


    const mutation = useMutation({
        mutationFn: (formData) => plainAxios.post(signupRoute, formData),
    });
    
    const handleSubmit = async (values, { setSubmitting, resetForm, setFieldValue, setFieldError }) => {
        setErrorText("");
        if (!isVerified) {
            setFieldError("mobile", "please Verify mobile number")
            return
        }

        if (!captchaValue) {
            setErrorText("Please complete the CAPTCHA!");
            return;
        }




        try {
            const cleanedValues = {
                ...values,
                firstname: values.firstname?.trim(),
                lastname: values.lastname?.trim(),
                username: values.username?.trim(),
                email: values.email?.trim(),
                mobile: values.mobile?.trim(),
            };

            let signUpResponse;

            if (role === "trainer") {
                const formData = new FormData();
                Object.entries(cleanedValues).forEach(([key, val]) => {
                    if (key !== "confirm_password") {

                        if (key === "resume" && val) {
                            formData.append("resume", val);

                        } else if (key === "preferred_subjects") {

                            formData.append(
                                "preferred_subjects",
                                JSON.stringify(
                                    selectedSubject.map(item => item?.label)
                                )
                            );

                        } else {
                            formData.append(key, val ?? "");
                        }
                    }
                });
                signUpResponse = await mutation.mutateAsync(formData);

            } else {
                // ✅ For all other roles, send JSON
                const filteredValues = {
                    ...Object.fromEntries(
                        Object.entries(cleanedValues).filter(([key]) => key !== "confirm_password")
                    ),

                    ...(role === "student" && { address: selectedApartmentDetail?.address }),
                    ...((role === "student" && !isStyingApartment) && { apartment_name: "Online" }),
                };

                signUpResponse = await mutation.mutateAsync(filteredValues);
            }

            // ✅ If sign up success → login automatically
            if (role !== "trainer") {
                if (signUpResponse?.data?.data) {
                    const loginResponse = await plainAxios.post(loginRoute, {
                        identifier: cleanedValues?.username,
                        password: cleanedValues?.password,
                    });
                    const user = loginResponse?.data?.data;
                    const token = loginResponse?.data?.token;
                    const refreshToken = loginResponse?.data?.refreshToken;
                    if (loginResponse?.data?.data) {
                        login(user, token);
                        const storedPath = localStorage.getItem("lastVisitedPath") || "/";
                        navigate(storedPath, { replace: true });
                        setTimeout(() => {
                            localStorage.removeItem("lastVisitedPath");
                        }, 500);

                        recaptchaRef.current?.reset();

                        setCaptchaValue(null);

                    } else {
                        showToaster("Error", "Something went wrong during login", "error");
                    }

                    resetForm();
                } else {
                    showToaster("Error", "Something went wrong during sign-up", "error");
                }
            } else {
                showToaster(
                    "Success",
                    "You have successfully signed up! We will review your application and respond as soon as possible.",
                    "success"
                );
                setSelectedSubject([])
                setSearchSubject({})
                resetForm();
                recaptchaRef.current?.reset();
                setCaptchaValue(null);
                setFieldValue("resume", "");
                setFieldValue("confirm_password", "");
                setIsVerified(false)
                setMobile("")
                setEmail("")
                setUserName("")
                setErrorText("")
            }

        } catch (error) {
            console.error("Error Response:", error.response);
            if (error.response?.data?.error) {
                const { errors } = error.response.data;
                setErrorText(error.response?.data?.error)
            } else {
                setErrorText("");
                showToaster("Error", "Something went wrong during sign-up", "error");
            }
        } finally {
            setSubmitting(false);
        }
    };


    const handleSubmitApartment = (values, { resetForm }) => {
        setSelectedApartmentDetail(values)
        resetForm()
        handleCloseAparment()
    };
    
    const handleSendOtp = async (phoneValue) => {
        if (!phoneValue) return;

        try {
            const response = await plainAxios.get("user/checkDetails", {
                params: {
                    type: role === "apartment" ? "apartment" : "user",
                    mobile: phoneValue,
                },
            });

            const isExist =
                response?.data?.results?.find((r) => r.field === "mobile")?.isExist;

            if (isExist) {
                showToaster("Warning", "Mobile already exists", "warning");
                return;
            }

            if (role === "apartment") {
                const verifyResponse = await plainAxios.get("contact-person", {
                    params: {
                        mobile_no: phoneValue,
                        apartment_id: apartmentId,
                    },
                });

                if (!verifyResponse?.data?.mobile_no) {
                    showToaster("Warning", verifyResponse?.data?.message, "warning");
                    return;
                }
            }

            // 3️⃣ Send OTP
            await sendOtpMutation.mutateAsync({ mobile: phoneValue });

            setMobile(phoneValue);
            handleClickOpen();
            startCountdown();
        } catch (error) {
            showToaster(
                "Error",
                error?.response?.data?.message || "Something went wrong",
                "error"
            );
        }
    };


    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnBlur={true}
                validateOnChange={false}
                enableReinitialize={true}
            >
                {({ setFieldValue }) => (
                    <Form>
                        <Grid2 container spacing={3} pb={2}>
                            {
                                role === "trainer" && (
                                    <Grid2 children size={{ xs: 12, sm: 12 }}>
                                        <Field
                                            name="resume"
                                            component={FileUploadFormField}
                                            label="Upload Resume"
                                            isRequired={true}
                                        />
                                    </Grid2>
                                )
                            }
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="firstname"
                                    component={TextFormField}
                                    label={getFirstNameLabel()}
                                    isRequired={true}
                                    type={"name"}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="lastname"
                                    component={TextFormField}
                                    label={getLastNameLabel()}
                                    isRequired={true}
                                    type={"name"}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="email"
                                    component={TextFormField}
                                    label="E-mail"
                                    isRequired={true}
                                    onChange={(value) => { setEmail(value) }}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="username"
                                    component={TextFormField}
                                    label="User Name"
                                    isRequired={true}
                                    onChange={(value) => { setUserName(value) }}
                                />
                            </Grid2>

                            {(role === "student" && isStyingApartment) && (
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="apartment_name"
                                        component={FormAutoComplete}
                                        options={ApartmentOptionsStu}
                                        label="Apartment"
                                        isRequired={true}
                                        isLoading={isLoadingApartmentList}
                                        onValueChange={(value, id) => {
                                            setSelectedApartmentDetail({ apartment_name: value });

                                        }}
                                        nooptionText={"Currently Unavailable"}
                                        // isShow={true}
                                        onClear={() => {
                                            setSelectedApartmentDetail(null);
                                        }}
                                        value={{ id: 1, value: selectedApartmentDetail?.apartment_name, label: selectedApartmentDetail?.apartment_name }}
                                        bottomContent={
                                            <Typography
                                                variant='body1'
                                                color="red.main"
                                                onClick={handleClickOpenApartment}
                                            >
                                                Didn’t find your apartment ??
                                            </Typography>
                                        }
                                    />
                                </Grid2>
                            )}

                            {(role === "apartment") && (
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="apartment_name"
                                        component={FormAutoComplete}
                                        options={ApartmentOptions}
                                        label="Apartment"
                                        isRequired={true}
                                        isLoading={isLoadingApartmentList}
                                        onValueChange={(_, id) => {
                                            setApartmentId(id)
                                        }}
                                        nooptionText={"Currently Unavailable"}
                                        isShow={true}

                                    />
                                </Grid2>
                            )}
                            {(role === "school") && (
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="school_name"
                                        component={FormAutoComplete}
                                        options={schoolOption}
                                        label="School"
                                        isRequired={true}
                                        isLoading={isSchoolLoading}

                                    />
                                </Grid2>
                            )}

                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="mobile"
                                    component={PhoneInputFormField}
                                    label="Mobile Number"
                                    isRequired={true}
                                    isOtpSent={isVerified}
                                    endIcon={
                                        <Typography variant="body2">
                                            {isVerified ? "verified" : "verify"}
                                        </Typography>}
                                    OnButtonClick={handleSendOtp}
                                    disabled={isVerified}

                                />
                            </Grid2>
                            {
                                (role === "trainer") && (
                                    <>
                                        <Grid2 children size={{ xs: 12, sm: 6 }}>
                                            <Field
                                                name="qualification"
                                                component={TextFormField}
                                                label="Qualification"
                                                isRequired={true}
                                            />
                                        </Grid2>

                                        <Grid2 size={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                            {selectedSubject?.map((item, index) => (
                                                <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />
                                            ))}
                                        </Grid2>

                                        <Grid2 children size={{ xs: 12, sm: 6 }}>
                                            <Field
                                                name="preferred_subjects"
                                                component={AutoCompleteField}
                                                isLoading={ispreferredSubjectLoading}
                                                options={preferredSubjectOption}
                                                onSearchChange={(val) => {
                                                    setSearchSubject(val)
                                                }}
                                                label="Preferred Subjects"
                                                isRequired={true}
                                                onValueChange={(newValue) => {
                                                    if (!newValue || !newValue.id) return;
                                                    setSelectedSubject((prev = []) => {
                                                        const exists = prev.find((item) => item.id === newValue?.id);
                                                        return exists ? prev : [...prev, newValue];
                                                    });
                                                    setFieldValue("preferred_subjects", "");
                                                }}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ xs: 12, sm: 6 }}>
                                            <Field
                                                name={"preferred_location"}
                                                component={AutoCompleteField}
                                                options={cityOption}
                                                label="Preferred City"
                                                isLoading={cityLoading}
                                                onValueChange={(value) => setCityId(value?.city_id)}
                                                nooptionText={"No Location found"}
                                                onSearchChange={(val) => {
                                                    setSearchCity(val)
                                                }}
                                                onClear={() => {
                                                    setSearchCity("")
                                                }}
                                            />
                                        </Grid2>
                                        <Grid2 children size={{ xs: 12, sm: 6 }}>
                                            <Field
                                                name={"preferred_zone"}
                                                component={AutoCompleteField}
                                                options={ZoneOption}
                                                label="Preferred Zone"
                                                isLoading={isLoadingZone}
                                                nooptionText={"No Zone found"}


                                            />
                                        </Grid2>
                                    </>
                                )
                            }

                            {
                                (role === "school") && (
                                    <>
                                        <LocationSelectorField
                                            countryField="country_name"
                                            stateField="state"
                                            cityField="city"
                                            isStoredId={false}
                                            zipField="zip"
                                            Input_Width={{ xs: 12, sm: 6 }}
                                            isShow
                                            passedCountryId={99}
                                            passedStateId={1233}
                                        />

                                    </>
                                )
                            }

                            {
                                (
                                    isVerified
                                ) && (
                                    <>
                                        <Grid2 size={{ xs: 12, sm: 6 }}>
                                            <Field
                                                name="password"
                                                component={TextFormField}
                                                label="Password"
                                                isRequired={true}
                                                type="password"
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, sm: 6 }}>
                                            <Field
                                                name="confirm_password"
                                                component={TextFormField}
                                                label="Confirm Password"
                                                isRequired={true}
                                                type="password"
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, sm: 6 }}>
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={CaptchaKey}
                                                onChange={handleCaptchaChange}
                                            />
                                        </Grid2>
                                    </>
                                )
                            }

                            <Grid2 children size={12}>
                                {errorText && <Typography variant="body2" fontSize={"10px"} color="#DC143C">{errorText}</Typography>}
                            </Grid2>
                            <Grid2 size={12}>
                                <Button variant='contained' fullWidth type="submit" disabled={mutation.isPending}>{mutation?.isPending ? "Signing Up" : "Sign Up"}</Button>
                            </Grid2>
                            <Grid2 children size={12}>
                                <OrDivider text={"Or"} />
                            </Grid2>
                            {bottomLine}
                        </Grid2>
                    </Form>
                )}
            </Formik>

            <MainDialogBox open={open} handleClose={handleClose} width={"40%"} heading={"Verify OTP"}>
                <Formik initialValues={{ mobile: "", otp: "" }}
                    validationSchema={yup.object().shape({
                        mobile: yup.string(),
                        otp: yup.string().required("OTP is required"),
                    })}
                    onSubmit={handleSubmitOtp}
                >
                    {() => (
                        <Form>
                            <Grid2 container spacing={"30px"}>
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                    Please enter the OTP sent to your WhatsApp.
                                </Typography>
                                <Grid2 children size={{ xs: 12, sm: 12 }}>
                                    <Field
                                        name="otp"
                                        component={TextFormField}
                                        label="Enter OTP"
                                        isRequired={true}
                                    />
                                    {countdown > 0 && (
                                        <Typography variant="body2" color="red.main" sx={{ mt: 1 }}>
                                            Time remaining: {Math.floor(countdown / 60)
                                                .toString()
                                                .padStart(2, '0')}:{(countdown % 60).toString().padStart(2, '0')}
                                        </Typography>
                                    )}
                                </Grid2>
                                <Typography
                                    onClick={() => {
                                        if (!reSendOtpMutation.isPending) {
                                            handleResendOtp();
                                        }
                                    }}
                                    sx={{ cursor: reSendOtpMutation.isPending ? 'default' : 'pointer', color: reSendOtpMutation.isPending ? "#FF809A" : 'red.main' }}
                                >
                                    {reSendOtpMutation?.isPending ? "Resending OTP" : "Resend OTP"}
                                </Typography>

                                <Grid2 children size={{ xs: 12, sm: 12 }}>
                                    <Button variant='contained' fullWidth type="submit" disabled={verifyOtpMutation.isPending}>{verifyOtpMutation.isPending ? "Verifing" : "Verify"}</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>

            <MainDialogBox open={openApartment} handleClose={handleCloseAparment} width={"40%"} >
                <ImgText text={"Apartment Not Found"} sx={{ textAlign: "center" }} variant='h6' />
                <CustomDivider size={"1rem"} />
                <Typography variant='body1' textAlign={"center"} fontWeight={200}>
                    It looks like this apartment is not listed yet.Please enter your apartment name to continue
                </Typography>
                <Formik
                    initialValues={{
                        apartment_name: "",
                        address: ""
                    }}
                    validationSchema={yup.object().shape({
                        apartment_name: yup.string().required('Apartment Name is required'),
                        address: yup.string().required('Address is required'),
                    })}
                    onSubmit={handleSubmitApartment}

                >
                    {() => (
                        <Form>
                            <CustomDivider size={"2rem"} />
                            <Grid2 container spacing={3} pb={2}>
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="apartment_name"
                                        component={TextFormField}
                                        label="Apartment"
                                        isRequired={true}

                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="address"
                                        component={TextFormField}
                                        label="Add Location"
                                        isRequired={true}
                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider size={"1rem"} />
                            <Grid2 container spacing={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Grid2 children size={{ xs: 6, sm: 5 }}>
                                    <Button variant='outlined' fullWidth onClick={() => { handleCloseAparment() }}>Cancel</Button>
                                </Grid2>
                                <Grid2 children size={{ xs: 6, sm: 5 }}>
                                    <Button variant='contained' fullWidth type="submit">Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>

            <MainDialogBox open={openChooseOp} handleClose={handleCloseChooseOp} width={"60%"}
                isShowCross={false}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                mainsx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    },
                }}
            >
                <ImgText text={"Apartment Stay Confirmation"} sx={{ textAlign: "center" }} variant='h6' />
                <CustomDivider size={"1rem"} />
                <Typography variant='body1' textAlign={"center"} fontWeight={200}>
                    Before you proceed, please confirm if you are currently staying in an apartment
                </Typography>
                <CustomDivider size={"1rem"} />
                <Grid2 container spacing={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid2 children size={{ xs: 6, sm: 6 }}>
                        <Button variant='outlined' fullWidth onClick={() => { setIsStyingApartment(true); handleCloseChooseOp() }}>Yes, I am staying</Button>
                    </Grid2>
                    <Grid2 children size={{ xs: 6, sm: 6 }}>
                        <Button variant='contained' fullWidth onClick={() => { setIsStyingApartment(false); handleCloseChooseOp() }}>No, I am not staying</Button>
                    </Grid2>
                </Grid2>

            </MainDialogBox>
        </>

    )
}

export default CommonNodeSignUpForm



